import { z } from 'zod';
import { IsoTimestamp } from './common';

/**
 * Rolling aggregate of external-apply hits whose destination host did NOT match
 * any of the ATSes the worker recognizes (`detectAtsName(...) === 'Unknown'`).
 * One row per canonical lowercased host. Used by admin tooling to identify the
 * most-common gaps in ATS coverage so we know which handlers to build next.
 *
 * - `sampleRunIds` keeps up to 5 recent runIds (FIFO) for quick cross-reference
 *   into the run detail.
 * - `sampleErrors` keeps up to 3 full event payloads (FIFO) — the first cut of
 *   triage reads these inline rather than chasing down the underlying run.
 */
export const UnknownAtsHostRoll = z.object({
  host: z.string(),
  count: z.number().int().nonnegative(),
  firstSeen: IsoTimestamp,
  lastSeen: IsoTimestamp,
  sampleRunIds: z.array(z.string()).max(5),
  sampleErrors: z
    .array(
      z.object({
        runId: z.string(),
        eventSeq: z.number().int(),
        capturedAt: IsoTimestamp,
        payload: z.unknown(),
      }),
    )
    .max(3),
});
export type UnknownAtsHostRoll = z.infer<typeof UnknownAtsHostRoll>;
